import loadable from '@loadable/component';

const ResearchPage = loadable(() => import('./page'));
const ResearchDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <ResearchPage />,
  },
  {
    path: ':id',
    element: <ResearchDashboardPage />,
  },
];
